import { SaborPedido } from "./SaborPedido"

export class SaboresPedidoAberto {
    pedidoItemId: number = 0
    sabores: SaborPedido[] = []
    clienteId?: string | null
}